import { SINGLE_UPLOAD_SIZE_LIMIT } from "src/app/constants"

function dateFormatter(val: string): string {
  return val
}
function normalizeStatus(value?: string | null): string | undefined {
  if (!value) {
    return undefined;
  }
  const normalized = value.toString();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}
export const DETAIL_COL_DEFINITION = [
  {
    headerName: 'File Name',
    field: 'filename',
  },
  {
    headerName: 'Masked File Name',
    field: 'masked_file_name',
  },
  {
    headerName: 'File Size',
    field: 'file_size',
  },
  {
    headerName: 'File Type',
    field: 'file_type',
  },
  {
    headerName: 'Upload Status',
    field: 'upload_status',
  },
  {
    headerName: 'Upload Transfer Rate',
    field: 'upload_transfer_rate',
  },
  {
    headerName: 'Case Number',
    field: 'case_number',
  },
  {
    headerName: 'PMBTA Status',
    field: 'pmbta_status',
  },
  {
    headerName: 'PMBTA Output',
    field: 'pmbta_result',
  },
  {
    headerName: 'Case Type',
    field: 'case_type',
  },
  {
    headerName: 'Time Zone',
    field: 'time_zone',
  },
  {
    headerName: 'Upload Type',
    field: 'upload_type',
    valueFormatter: (row: any) => {
      return row.file_size < SINGLE_UPLOAD_SIZE_LIMIT ? 'S' : 'M'
    }
  },
  {
    headerName: 'Upload Start Time',
    field: 'upload_start_time',
    valueFormatter: (row: any) => {
      return dateFormatter(row.upload_start_time)
    }
  },
  {
    headerName: 'Upload End Time',
    field: 'upload_end_time',
    valueFormatter: (row: any) => {
      return dateFormatter(row.upload_end_time)
    }
  },
  {
    headerName: 'Upload Cancel Time',
    field: 'upload_cancel_time',
    valueFormatter: (row: any) => {
      return dateFormatter(row.upload_cancel_time)
    }
  },
  {
    headerName: 'Upload Progress',
    field: 'percentage_done',
     valueFormatter: (row: any) => {
      return row.percentage_done ? row.percentage_done : row.upload_status === 'COMPLETE' ? '100' : '0'
    }

  },
    {
    headerName: 'Automation Status',
    field: 'automationStatus',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.automationStatus;
      return normalizeStatus(status);
    }
  },
  {
    headerName: '',
    field: 'actions',
    isAction: true
  },
  {
    headerName: 'Core Tool Status',
    field: 'coreToolStatus',
    valueFormatter: (row: any) => {
  const status = row.automationToolStatus?.toolStatus?.coreTool?.coreToolStatus;
  return normalizeStatus(status);
}
  },
  {
    headerName: 'Coregdb Tool Status',
    field: 'coregdbStatus',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.toolStatus?.coregdb?.coregdbStatus;
      return normalizeStatus(status);
    }
  },
  {
    headerName: 'PMBTA Tool Status',
    field: 'pmbtaStatus',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.toolStatus?.pmbta?.pmbtaStatus;
      return normalizeStatus(status);
    }
  },
  {
    headerName: 'Bsa Slow Status',
    field: 'bsaslowStatus',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.toolStatus?.bsaslow?.bsaslowStatus;
      return normalizeStatus(status);
    }
  },
  {
    headerName: 'Bsa Fast Status',
    field: 'bsafastStatus',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.toolStatus?.bsafast?.bsafastStatus;
      return normalizeStatus(status);
    }
  },
  {
    headerName: 'Automation Start Time',
    field: 'automationStartTime',
     valueFormatter: (row: any) => {
      const status = row.automationToolStatus?.automationStartTime;
      return normalizeStatus(status);
    }
  },
  {
    headerName: 'Automation End Time',
    field: 'automationEndTime',
    valueFormatter: (row: any) => {
      return dateFormatter(row.automationToolStatus?.automationEndTime)
    }
  },

]
  